module.exports = __webpack_public_path__ + "static/media/success-background.11f6671e.svg";